module.exports = __webpack_public_path__ + "img/gauge-simple.08e3683b.svg";